export enum ContextListControlsEnum {
  always = 'always',
  never = 'never',
  default = 'default'
}
